import { useReducer } from 'react';

import { statusShortcuts } from '../../../../hooks/entity/status_shortcuts';
import type {
  FetchStatusType,
  StatusType,
} from '../../../../hooks/entity/status_type';

type ApiReducerState = {
  fetchStatus: FetchStatusType;
  status: StatusType;
  data: unknown;
};

const initialState: ApiReducerState = {
  fetchStatus: 'fetching',
  status: 'pending',
  data: null,
};

export const ACTION_TYPE = {
  START: 'START',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

type State = typeof initialState;
type StartAction = { type: typeof ACTION_TYPE.START };
type SuccessAction = { type: typeof ACTION_TYPE.SUCCESS; payload: unknown };
type ErrorAction = { type: typeof ACTION_TYPE.ERROR };

type Action = StartAction | SuccessAction | ErrorAction;

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ACTION_TYPE.START:
      return { ...state, status: 'pending', fetchStatus: 'fetching' };
    case ACTION_TYPE.SUCCESS:
      return {
        ...state,
        status: 'success',
        fetchStatus: 'idle',
        data: 'payload' in action ? action.payload : null,
      };
    case ACTION_TYPE.ERROR:
      return { ...state, status: 'error', fetchStatus: 'idle', data: null };
    default:
      return state;
  }
};

// TODO: RP-1699 Refactor/reconsider data-fetching for metadata
export function useApiReducer() {
  const [state, apiDispatch] = useReducer(reducer, initialState);

  return [
    {
      ...state,
      ...statusShortcuts(state.status, state.fetchStatus),
    },
    apiDispatch,
  ] as const;
}
